import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {FormArray, FormControl, FormGroup} from '@angular/forms';
import {FontAwesomeService} from '@services/font-awesome.service';

@Component({
  selector: 'app-products-form',
  templateUrl: './products-form.component.html',
  styleUrls: ['./products-form.component.scss']
})

export class ProductsFormComponent implements OnInit {
  @Input() parent: FormGroup;
  @Input() submitted: boolean;
  @Input() product_id: number;
  @Input() filters: any;
  @Output() updateFormData: EventEmitter<any> = new EventEmitter();

  constructor(
    public faService: FontAwesomeService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {

  }

  static generateForm() {
    return new FormGroup({
      product_id: new FormControl(''),
      filters: new FormControl('')
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/consignment/search/components/products-form/products-form.component.ts